import "./OurMission.module.css";
import CommandCenterHeader from "@/reusable_sections/Header";
import VeteranBuiltLegacy from "./sections/VeteranBuiltLegacy";
import TheAiGuyzTeam from "./sections/TheAiGuyzTeam";
import OurCoreValues from "./sections/OurCoreValues";
import BaseOperationsFooter from "@/reusable_sections/Footer";
export default function OurMissionPage() {
  return <div>
      <CommandCenterHeader />
      <VeteranBuiltLegacy />
      <TheAiGuyzTeam />
      <OurCoreValues />
      <BaseOperationsFooter />
    </div>;
}